import { CONTACT } from "../lib/data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="px-6 md:px-12 pt-20 pb-12 border-t border-soft">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-7">
            <div className="font-display text-3xl md:text-4xl text-strong leading-tight font-medium max-w-xl">
              Quietly building the <span className="serif-italic text-accent">execution layer</span> for silicon.
            </div>
          </div>
          <div className="md:col-span-5 flex flex-col md:items-end gap-2 text-sm">
            <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="text-accent hover:opacity-80 font-medium transition-colors">
              {CONTACT.email}
            </a>
            <a href={`tel:${CONTACT.phone.replace(/[^+\d]/g, "")}`} data-testid="footer-phone" className="text-strong hover:text-accent transition-colors">
              {CONTACT.phone}
            </a>
            <span className="text-muted mt-1">India</span>
          </div>
        </div>
        <div className="section-divider mt-16 mb-6" />
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-faint tracking-wide">
          <div>© {new Date().getFullYear()} SemiconOS. All rights reserved.</div>
          <div className="uppercase tracking-[0.2em]">semiconos.ai</div>
        </div>
      </div>
    </footer>
  );
}
